import React, { useState } from "react";
import { Form, Card, Row, Col } from "react-bootstrap";

function StarterCalculator() {
  const [starterWeight, setStarterWeight] = useState("");
  const [flourAdded, setFlourAdded] = useState("");
  const [waterAdded, setWaterAdded] = useState("");

  const calculateRatio = () => {
    if (!starterWeight || !flourAdded || !waterAdded) return null;
    const ratio =
      (parseFloat(flourAdded) + parseFloat(waterAdded)) /
      parseFloat(starterWeight);
    return ratio.toFixed(2);
  };

  return (
    <div>
      <h2 className="mb-4">Starter Feeding Ratio Calculator</h2>
      <Card className="mb-4">
        <Card.Body>
          <p className="mb-3">
            Calculate the feeding ratio for your sourdough starter. A higher
            ratio means more food for your starter, which can make it more
            active. Common ratios range from 1:1:1 to 1:5:5
            (starter:flour:water).
          </p>
          <Form>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Existing Starter Weight (g)</Form.Label>
                  <Form.Control
                    type="number"
                    value={starterWeight}
                    onChange={(e) => setStarterWeight(e.target.value)}
                    placeholder="e.g., 50"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Flour Added (g)</Form.Label>
                  <Form.Control
                    type="number"
                    value={flourAdded}
                    onChange={(e) => setFlourAdded(e.target.value)}
                    placeholder="e.g., 100"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Water Added (g)</Form.Label>
                  <Form.Control
                    type="number"
                    value={waterAdded}
                    onChange={(e) => setWaterAdded(e.target.value)}
                    placeholder="e.g., 100"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {calculateRatio() && (
        <Card className="bg-light">
          <Card.Body>
            <h4>Feeding Ratio Result</h4>
            <p className="mb-0">
              Your feeding ratio is <strong>{calculateRatio()}:1</strong>
            </p>
            <small className="text-muted">
              This means for every 1 part of starter, you're adding{" "}
              {calculateRatio()} parts of fresh ingredients (flour + water
              combined).
            </small>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}

export default StarterCalculator;
